// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Vuex from 'vuex';
import Meta from 'vue-meta';
import VueCookie from 'vue-cookie';
import VueResource from 'vue-resource';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import InfiniteScroll from 'vue-infinite-scroll';
import SocialSharing from 'vue-social-sharing';

import polyFileList from '@/utils/pollyfillFileList';
import getCookie from '@/utils/cookies';

import App from './App';
import store from './store';
import router from './router';

Vue.use(Vuex);
Vue.use(Meta);
Vue.use(VueCookie);
Vue.use(VueResource);
Vue.use(VueAwesomeSwiper);
Vue.use(InfiniteScroll);
Vue.use(SocialSharing);

polyFileList();

Vue.http.interceptors.push((request, next) => {  // store django's CSRF token
  const token = getCookie('csrftoken');
  request.headers.set('X-CSRFToken', token);
  next();
});

Vue.http.options.root = '/api';

new Vue({  // eslint-disable-line no-new
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js